const BASE_API = 'https://endless.dilokuluburada.com/api'
const BASE_YES_API = process.env.MIX_ENDLESS_API_URL

const state ={
	createStudentComplated:false,
	createStudentLoading:false,
	createStudentLoadingComplete:false,
	createStudentWithQuoteLoading:false,
	createStudentWithQuoteLoadingComplete:false,

}
const getters = {
	createStudentLoading:({createStudentLoading}) => createStudentLoading,
	createStudentLoadingComplete:({createStudentLoadingComplete}) => createStudentLoadingComplete,
	createStudentWithQuoteLoading:({createStudentWithQuoteLoading}) => createStudentWithQuoteLoading,
	createStudentWithQuoteLoadingComplete:({createStudentWithQuoteLoadingComplete}) => createStudentWithQuoteLoadingComplete,
}
const mutations = {}
const actions = {
	async createStudent({commit, state}, payload){
		state.createStudentLoading = true
		await this.$axios.post(`${BASE_API}/create-student`,payload.data).then(res => {
			state.createStudentLoading = false
			state.createStudentLoadingComplete = true
			setTimeout(function () {
				state.createStudentLoadingComplete = false
			}, 4000);
		}).catch(()=>{
			state.createStudentLoading = false
		})
	},
	async createStudentWithQuote({commit, state}, payload){
		state.createStudentWithQuoteLoading = true
		await this.$axios.post(`${BASE_YES_API}/create-student-with-quote`,payload.data).then(res => {
			state.createStudentWithQuoteLoading = false
			state.createStudentWithQuoteLoadingComplete = true
			setTimeout(function () {
				state.createStudentWithQuoteLoadingComplete = false
			}, 4000);
		}).catch(()=>{
			state.createStudentLoading = false
		})
	},


}

export default {namespaced:true,state,getters,mutations,actions}
